import {
  ACCEPT_TOS_PRIVACY,
  SET_TOS_PRIVACY,
  SHOW_TOS_PRIVACY,
} from './actions';

const INITIAL_STATE = {
  acceptedTOS: false,
  showTerms: false,
};

export const tosPrivacy = (
  state = INITIAL_STATE,
  { type, payload }: any = {},
) => {
  switch (type) {
    case ACCEPT_TOS_PRIVACY:
      return { ...state, acceptedTOS: true };
    case SET_TOS_PRIVACY:
      return { ...state, ...payload };
    case SHOW_TOS_PRIVACY:
      return { ...state, ...payload };
    default:
      return state;
  }
};
